import { CHANGE_THEME } from './constants';

export const changeTheme = (payload: boolean) => {
    return {
        type: CHANGE_THEME,
        payload
      };
  }